import teamingAppIcon from "@/assets/images/TeamingApp.png"

export const DEFAULT_ORGANIZATION_NAME = "Teaming App"

export type OrganizationBrand = {
	name?: string | null
	logo?: string | null
	default_image?: string | null
} | null | undefined

export function firstNonEmptyUrl(...values: Array<string | null | undefined>): string | null {
	for (const value of values) {
		if (typeof value === "string" && value.trim()) {
			return value.trim()
		}
	}
	return null
}

/**
 * Start-screen logo: organization default image, then the Teaming App icon.
 * The organization logo is never shown here.
 */
export function resolveOrganizationLogo(
	organization: OrganizationBrand,
	fallback: string = teamingAppIcon
): string {
	return firstNonEmptyUrl(organization?.default_image) ?? fallback
}

/** Organization display name, or "Teaming App" when missing. */
export function resolveOrganizationName(
	organization: OrganizationBrand,
	fallback: string = DEFAULT_ORGANIZATION_NAME
): string {
	const name = organization?.name
	if (typeof name === "string" && name.trim()) {
		return name.trim()
	}
	return fallback
}

/** Vite-bundled files must not be prefixed with the API host. */
export function isBundledAssetUrl(url: string): boolean {
	return (
		url === teamingAppIcon ||
		url.startsWith("/assets/") ||
		url.startsWith("/src/") ||
		url.startsWith("assets/")
	)
}

/** True when the resolved URL is the Teaming App icon fallback. */
export function isTeamingAppIcon(url: string | null | undefined): boolean {
	if (!url || typeof url !== "string") return false
	const trimmed = url.trim()
	return trimmed === teamingAppIcon || trimmed.includes("TeamingApp")
}

export { teamingAppIcon }
